import { useNavigate } from "react-router-dom";
import { Button, Panel, Typography } from "@/components/atoms";
import { useOperator } from "@/hooks";

interface CancelSubscriptionSectionProps {
  onCancelClick: () => void;
  isPendingCancellation?: boolean;
  cancellationDate?: string;
  hasNoSubscription?: boolean;
}

export const CancelSubscriptionSection = ({ onCancelClick, isPendingCancellation, cancellationDate, hasNoSubscription }: CancelSubscriptionSectionProps) => {
  const navigate = useNavigate();
  const operator = useOperator();

  if (hasNoSubscription) {
    return (
      <Panel className="flex flex-row items-center justify-between">
        <div className="flex flex-col gap-2">
          <Typography variant="title">No Active Subscription</Typography>
          <Typography variant="paragraph" className="text-neutral-dark-gray">
            You don&apos;t have an active subscription. Subscribe to a plan to get started with RideMinder.
          </Typography>
        </div>
        <Button variant="primary" size="sm" onClick={() => navigate(`/operator/${operator.id}/payments/subscriptions/subscription-plan`)}>
          Subscribe
        </Button>
      </Panel>
    );
  }

  if (isPendingCancellation) {
    return (
      <Panel className="flex flex-row items-center justify-between">
        <div className="flex flex-col gap-2">
          <Typography variant="title">Subscription Cancelled</Typography>
          <Typography variant="paragraph" className="text-neutral-dark-gray">
            Your subscription has been cancelled.{cancellationDate ? ` You will have access until ${cancellationDate}.` : ""}
          </Typography>
        </div>
        <Button variant="primary" size="sm" onClick={() => navigate(`/operator/${operator.id}/payments/subscriptions/subscription-plan`)}>
          Re-activate
        </Button>
      </Panel>
    );
  }

  return (
    <Panel className="flex flex-row items-center justify-between">
      <div className="flex flex-col gap-2">
        <Typography variant="title">Cancel Subscription</Typography>
        <Typography variant="paragraph" className="text-neutral-dark-gray">
          Stopping your subscription will end access to RideMinder on your next billing date. You&apos;ll still have full access until then.
        </Typography>
      </div>
      <Button variant="secondary" size="sm" onClick={onCancelClick}>
        Cancel Subscription
      </Button>
    </Panel>
  );
};
